import React__default from 'react';
import styled from '../../../../../../node_modules/@mui/material/styles/styled.mjs';

const StyledLabelContainer = styled('span')(()=>({
        display: 'flex',
        alignItems: 'center'
    }));
const LabelCore = ({ children, disabled, htmlFor, required, variant = 'body2', TypographyComponent: Typography, labelColor })=>{
    return /*#__PURE__*/ React__default.createElement(StyledLabelContainer, null, /*#__PURE__*/ React__default.createElement("label", {
        "aria-required": required,
        htmlFor: htmlFor
    }, /*#__PURE__*/ React__default.createElement(Typography, {
        color: labelColor,
        disabled: disabled,
        variant: variant
    }, children)), required && /*#__PURE__*/ React__default.createElement(Typography, {
        color: "error",
        disabled: disabled,
        variant: "body2"
    }, "*"));
};

export { LabelCore };
//# sourceMappingURL=Label.mjs.map
